////////LIBRARY/////////
import { isNull } from 'lodash'

class ValueCheck {
	/**
	 * @param { string } value price of item
	 * @param { string } symbol character if we dont have price
	 * @param { string } currency money that we use
	 */

	static ValueCheck(value, symbol = '-', currency = '€') {
		let regex = RegExp(/€/g)

		if (isNull(value) || value?.length === 0) {
			return `${symbol}`
		} else if (!isNull(value) || value?.length > 0) {
			if (value.search(regex) === -1) {
				return `${value}${currency}`
			} else {
				return `${value.replace(regex, `${currency}`)}`
			}
		}
	}
}

export default ValueCheck
